const updateAboutCache = (queryClient, stockData) => {
  stockData.forEach((stock) => {
    // query keys is based on packages/stock/src/services/stock/detail/about/index.js
    queryClient.setQueryData([`v1/stock/detail/${stock.code}/about/`], (oldData) => {
      // return new data if old data is not found
      if (!oldData) {
        return {
          code: stock.code,
          name: stock.name,
          icon_url: stock.icon_url,
        };
      }
      return {
        ...oldData?.data,
        code: stock.code,
        name: stock.name,
        icon_url: stock.icon_url,
      };
    });
  });
};

export default updateAboutCache;
